module.exports = __webpack_public_path__ + "34bc775d/img/rename-icon.de4e673d.svg";